import dashboardService from "@/api/dashboardService";

const state = {
    dashboard: [],
    prods: [],
    years: [],
    currentYear: new Date().getFullYear(),
    activatedTenants: [],
    deActivatedTenants: [],
    selctedYear:0,
    selectedProd: 0,
    selectedProdName: '',
    noOfVehicles:[],
    noOfEmployees: [],
    noOfTrips:[],
}
const getters = {
    // dashboard: state => state.dashboard,
    getTenantVehicles: (state) => state.noOfVehicles,
    getTenantEmployees: (state) => state.noOfEmployees,
    getTenantsByTrips: (state) => state.noOfTrips,
};

const actions = {
    async getTenantDetails({commit}, productId){
        const response = await dashboardService.getTenantDetails(productId);
        commit('getTenantDetails', response.data.result)
    },
    async getTenantDetailsOnYear({state, commit}, data) {
        const response = await dashboardService.getTenantDetailsOnYear(data);
        state.selctedYear = data.year
        state.selectedProd = data.productID
        state.dashboard = response.data
        state.activatedTenants = []
        state.dashboard.forEach(session => {
            state.activatedTenants.push(session.activatedTenants)
        });
        state.deActivatedTenants = []
        state.dashboard.forEach(session => {
            state.deActivatedTenants.push(session.deactivatedTenants)
        });
        commit('getActivatedTenants',state.activatedTenants)
        commit('getDeactivatedTenants', state.deActivatedTenants)
        commit('getTenantDetailsOnYear', response.data.result)
    },
    async getYears({commit}) {
        const response = await dashboardService.getYears();
        state.years = response.data
        commit('getYears')
    },
    async getProducts({commit} ) {
        const response = await dashboardService.getProducts();
        state.prods = response.data
        console.log("Products in getProducts JS : ",state.prods)
        commit('getProducts')
    },
    async getTenantDetailsOnProductName({state, commit}, productName) {
        const response = await dashboardService.getTenantDetailsOnProductName(productName);
        if(response && response.data && response.data.result) {
        state.selectedProdName = productName;
        let dashboard = response.data.result;
        if(productName == 'VTS') {
        state.noOfVehicles = []
        dashboard.forEach(session => {
            state.noOfVehicles.push(session)
        });
        commit('getNoOfVehicles', response.data.result)
        } else if(productName == 'ETMS') {
        state.noOfEmployees= []
        dashboard.forEach(session => {
            state.noOfEmployees.push(session)
        });
        commit('getNoOfEmployees', response.data.result)
        }
    }
    },
    async getTenantTripDetailsOnProductName({state, commit}, data) {
        const response = await dashboardService.getTenantTripDetailsOnProductName(data.productName,data.year);
        state.selectedProdName = data.productName;
        if(response && response.data && response.data.result) {
        let dashboard = response.data.result;
        if(data.productName == 'ETMS') {
        state.noOfTrips = []
        dashboard.forEach(session => {
            state.noOfTrips.push(session)
        });
        commit('getNoOfTrips', response.data.result)
        }
        }
    },
}


const mutations = {
    getTenantDetails(state,tenantData){
        state.tenantData = tenantData
    },
    getTenantDetailsOnYear(state, dashboard) {
        state.dashboard = dashboard;
    },
    getYears(state, years) {
        state.year = years
    },
    getProducts(state, product) {
        state.product = product;
    },
    getActivatedTenants(state, activatedTenants) {
        state.activatedTenants = activatedTenants
        console.log("Activated : ",activatedTenants)
    },
    getDeactivatedTenants(state, deActivatedTenants) {
        state.deActivatedTenants = deActivatedTenants
        console.log("De activated : ",deActivatedTenants)
    },
    getNoOfVehicles(state, noOfVehicles) {
        state.noOfVehicles = noOfVehicles;
    },
    getNoOfEmployees(state, noOfEmployees) {
        state.noOfEmployees = noOfEmployees;
    },
    getNoOfTrips(state, noOfTrips) {
        state.noOfTrips = noOfTrips;
    },
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}